import React from 'react'

export default function Left() {
    return (
        <>
            <h1>There’s a smarter way to OYO around</h1>
            <p>Sign up with your phone number and get exclusive access to discounts and savings on OYO stays and with our many travel partners.</p>
        </>
    )
}